import { Destination } from '../Destination/Destination';
import { DistanceDuration } from '../DistanceDuration/DistanceDuration';
import { CardinalDivision, CardinalPoint } from '../../utilities/DivideByCardinalPoint';
import * as moment from 'moment';
export class Area{
    
    email = null;
    phone = null;
    comments = null;
    fee = 0;
    collection = 0;
    signature: any;
    picture: any;
    destinations: Array<Destination>
    address : string;
    pickup_address:string;
    zone:string;
    id:number;
    droppedOff: boolean = false;
    centralPoint = false;
    dropOffTime:Date;
    distaneStringFromLastPoint:string;
    durationStringFromLastPoint:string;
    totalDuration:number = 0;
    totalDurationString:string;
    totalDistance:number = 0;
    totalDistanceString:string;

    distanceFromLastPoint:number;
    durationFromLastPoint:number;
    userid:number;
    employeeid:any;
    department:any;
    companyid:number;
    locationid:number;
    weekid:number;
    pickupid:number
    distanceDurationFromSource:DistanceDuration;
    cardinalDirectionFromSource:CardinalPoint;
    outlier:boolean = false;
    clusterId:string = null;
    slotTime:Date; 
    
    constructor(id:number,address:string,slotTime:Date,destinations:Array<Destination>,centralPoint:boolean){

        this.slotTime = slotTime;
        this.address = address;
        this.destinations = destinations;
        this.fee = 0;
        this.collection = 0;
        this.destinations.forEach(d =>{
            d.employeeid = this.employeeid;
        })
        this.id = id;
        this.centralPoint = centralPoint;
    }



    getLatLng() : LatLng{
        return {
            lat:parseFloat(this.destinations[0].lat.toString()),
            lng:parseFloat(this.destinations[0].lng.toString())
        };
    }

    getLatLngKey(){
        var m = this.getLatLng();
        return `${m.lat}|${m.lng}`;
    }

    static createAreaFromJson(jsonObj){

        var a = new Area(-1,"",null,[],null);
        var area = Object.assign(a,jsonObj);
        return area;
    }

    static copy(area:Area){
        return this.copyAreas([area])[0];
    }

    static copyAreas(areas:Array<Area>){

        var newAreas = new Array<Area>();

        areas.forEach(a =>{
            var jsonObj = JSON.parse(JSON.stringify(a));
            newAreas.push(Area.createAreaFromJson(jsonObj));
        });

        return newAreas;
    }
}